import { makeStyles, tokens } from '@fluentui/react-components';
import { ReactNode } from 'react';

interface Props {
  children?: ReactNode | Iterable<ReactNode>
}

export function Page(props: Props) {
	const classes = useStyles();
  
	return (
		<div className={classes.root}>
			<div className={classes.content}>
				{props?.children}
			</div>
		</div>
	);
}

const useStyles = makeStyles({
	root: {
		position: 'relative',
		backgroundColor: tokens.colorNeutralBackground2,
		width: '100vw',
		height: '100vh'
	},
	content: {
		width: '100%',
		height: '100%',
		position: 'absolute',
		overflowY: 'scroll'
	}
});